import { useRecoilState } from 'recoil';
import { bottomDrawerExpandedState } from 'states';
import FullscreenSharpIcon from '@mui/icons-material/FullscreenSharp';
import FullscreenExitSharpIcon from '@mui/icons-material/FullscreenExitSharp';
import useIsMobile from 'hooks/useIsMobile';
import { ChartSizingButton } from './ChartSizingButton';

export const FullscreenBottomDrawerButton = ({
  withText,
}: {
  withText?: boolean;
}) => {
  const [bottomDrawerExpanded, setBottomDrawerExpanded] = useRecoilState(
    bottomDrawerExpandedState,
  );
  const isMobile = useIsMobile();
  if (isMobile) {
    return null;
  }

  return (
    <ChartSizingButton
      onClick={() => {
        setBottomDrawerExpanded(!bottomDrawerExpanded);
      }}
      icon={
        bottomDrawerExpanded ? (
          <FullscreenExitSharpIcon />
        ) : (
          <FullscreenSharpIcon />
        )
      }
      title={
        bottomDrawerExpanded
          ? 'Minimize Bottom Drawer'
          : 'Maximize Bottom Drawer'
      }
      withText={withText}
      analyticsName="bottom-drawer-fullscreen"
    />
  );
};
